const {
  CONTRACT_INDEX_DEPOSIT_18_MONTHS_RETENTION,
  CONTRACT_INDEX_DEPOSIT_24_MONTHS_RETENTION,
  CONTRACT_INDEX_COMBINED_DEPOSIT,
} = require('constants/index');

const CONTRACT_TYPES_THAT_NEEDS_HYDRATION = [
  CONTRACT_INDEX_DEPOSIT_18_MONTHS_RETENTION,
  CONTRACT_INDEX_DEPOSIT_24_MONTHS_RETENTION,
  CONTRACT_INDEX_COMBINED_DEPOSIT,
];

export const isAContractThatNeedsHydration = contractType => CONTRACT_TYPES_THAT_NEEDS_HYDRATION.includes(contractType);
